<template>
  <div class="my-5" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-9' : 'px-5'">
    <v-row justify="end">
      <v-col cols="12" md="3">
        <v-btn v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')"
          :color="style.primary"
          dark
          elevation="3"
          class="text-capitalize"
          to="/project/create">
          <v-icon small class="mr-1">mdi-plus</v-icon>
          Proyek baru
        </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          outlined
          dense
          :hide-details="true"
          placeholder="Nama proyek . . ."
          clearable
          :color="style.primary"
          v-model="filter.title"
          @click:clear="filter.title = ''; fetch();"
          v-on:keyup.enter="fetch()"
          prepend-inner-icon="mdi-magnify">
        </v-text-field>
      </v-col>
      <v-col cols="12" md="2">
        <v-select
          outlined
          dense
          single-line
          :items="config.category"
          item-text="project_category_name"
          item-value="project_category_name"
          item-color="green lighten-2"
          v-model="filter.category"
          :hide-details="true"
          label="Kategori">
          <template v-slot:append>
            <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" md="3">
        <div class="v-input v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
          <div class="v-input__control">
            <div class="v-input__slot">
              <div class="v-input__prepend-inner">
                <div class="v-input__icon v-input__icon--prepend-inner">
                  <i aria-hidden="true" class="v-icon notranslate mdi mdi-home-map-marker theme--light"></i>
                </div>
              </div>
              <fieldset aria-hidden="true">
                <legend style="width: 0px;">
                  <span>​</span>
                </legend>
              </fieldset>
              <div class="v-text-field__slot">
                <label for="input-147" class="v-label theme--light" style="left: 0px; right: auto; position: absolute;">
                  <!-- Alamat / Lokasi Proyek -->
                </label>
                <gmap-autocomplete placeholder="Alamat / Lokasi Proyek" :value="filter.location" :select-first-on-enter="true" @place_changed="setPlace"></gmap-autocomplete>
              </div>
            </div>
            <div class="v-text-field__details">
              <div class="v-messages theme--light">
                <div class="v-messages__wrapper">
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
      <!-- <v-col cols="12" md="2">
        <v-select
          outlined
          dense
          item-color="light-blue lighten-2"
          single-line
          :hide-details="true"
          label="Status">
          <template v-slot:append>
            <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
          </template>
        </v-select>
      </v-col> -->
    </v-row>

    <v-row justify="end">
      <v-col md="10">
        <p class="caption text-third">
          Ditampilkan
          <span class="subtitle-2 text-second">
            {{ pagination.total_display }}
          </span>
          dari {{ pagination.total_data }}
        </p>
      </v-col>
      <v-col md="2" class="d-flex align-center justify-end">
        <v-slide-group 
          v-model="selected.year"
          class="d-flex align-center"
          show-arrows
          center-active>
          <v-slide-item
            v-for="(item, index) in years"
            :key="index"
            v-slot:default="{ active, toggle }">
            <v-btn
              class="mx-5 caption text-capitalize"
              x-small
              width="75"
              :input-value="active"
              active-class="light-green white--text"
              elevation="0"
              rounded
              @click="toggle">
              {{ item.label }}
            </v-btn>
          </v-slide-item>
          <template v-slot:prev>
            <v-icon :disabled="selected.year < 1" @click="selected.year = selected.year - 1">mdi-chevron-left-box</v-icon>
          </template>
          <template v-slot:next>
            <v-icon :disabled="selected.year >= years.length - 1" @click="selected.year = selected.year + 1">mdi-chevron-right-box</v-icon>
          </template>
        </v-slide-group>
      </v-col>
    </v-row>

    <v-row :class="pagination.total_page > 12 ? 'min-height' : ''">
      <v-col cols="12" md="3"
        v-for="(item, index) in process.run ? 8 : list"
        :key="index">
        <v-skeleton-loader
          class="ma-auto"
          :loading="process.run"
          transition="scale-transition"
          :tile="false"
          type="card">
          <v-hover v-slot:default="{ hover }">
            <v-card
              class="border-radius box-shadow"
              v-show="!process.run && list.length > 0">
              <v-card-text class="pa-3">
                <v-row align="center">
                  <v-col cols="4" class="py-0 pr-0">
                    <v-img
                      style="border-radius: 5px;"
                      class="align-center"
                      width="75"
                      height="75"
                      :src="item.project_image_url">
                    </v-img>
                  </v-col>
                  <v-col cols="8" class="py-0 px-0">
                    <v-card-text class="text-third py-0 caption">
                      {{ item.project_city_name }}
                    </v-card-text>
                    <v-card-title class="caption font-weight-bold text-second py-0 d-flex align-start"
                      style="height: 40px;">
                      {{ item.project_name }}
                    </v-card-title>
                  </v-col>
                </v-row>
                <v-row justify="center" align="end" class="py-3">
                  <v-col cols="8" class="px-0">
                    <v-card-text class="text-third py-0 caption">
                      Unit Terjual
                      <v-progress-linear
                        :buffer-value="item.project_unit_total < 100 ? 100 : item.project_unit_total"
                        :value="item.project_unit_sold"
                        :color="item.project_unit_sold < 1 ? `red` : style.primary">
                      </v-progress-linear>
                    </v-card-text>
                  </v-col>
                  <v-col cols="4" class="text-right text-third caption">
                    {{ item.project_unit_sold }} / {{ item.project_unit_total }} Unit
                  </v-col>
                </v-row>
                <v-row justify="end" align="center">
                  <v-col cols="12" class="subtitle-2 light-blue--text text-right py-0">
                    <v-chip
                      small
                      :color="style.primary"
                      class="text-capitalize white--text">
                      {{ item.project_published_status }}
                    </v-chip>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-expand-transition>
                <div
                  v-if="hover"
                  class="d-flex transition-fast-in-fast-out light-green lighten-2 v-card--reveal display-3 white--text"
                  style="height: 100%;">
                  <!-- <v-btn
                    small
                    fab
                    min-width="30"
                    class="text-capitalize orange--text pa-0 mx-1"
                    :to="`project/update/${item.project_id}`">
                    <v-icon small>mdi-pencil-outline</v-icon>
                  </v-btn>
                  <v-btn
                    small
                    fab
                    min-width="30"
                    :class="item.project_published_status === 'publish' ? 'grey--text' : 'teal--text'"
                    class="text-capitalize pa-0 mx-1">
                    <v-icon small>{{ item.project_published_status === 'publish' ? 'mdi-upload-off' : 'mdi-upload' }}</v-icon>
                  </v-btn>
                  <v-btn
                    small
                    fab
                    min-width="30"
                    class="text-capitalize blue--text pa-0 mx-1"
                    :to="`project/detail/${item.project_id}`">
                    <v-icon small>mdi-information-outline</v-icon>
                  </v-btn> -->
                  <v-btn v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')"
                    small
                    elevation="0"
                    class="text-capitalize orange--text mx-1"
                    :to="`project/update/${item.project_id}`">
                    <v-icon small class="mr-1">mdi-pencil-outline</v-icon>
                    Ubah
                  </v-btn>
                  <v-btn
                    small
                    elevation="0"
                    class="text-capitalize green--text mx-1"
                    :to="`project/detail/${item.project_id}`">
                    <v-icon small class="mr-1">mdi-information-outline</v-icon>
                    Detail
                  </v-btn>
                </div>
              </v-expand-transition>
            </v-card>
          </v-hover>
        </v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row justify="center" align="center" v-if="!process.run && pagination.total_page < 1">
      <v-col cols="12" class="d-flex align-center mt-12">
        <v-img 
          class="mt-12"
          contain
          width="200"
          height="200"
          :src="require('../../../assets/404/404.svg')">
        </v-img>
      </v-col>
    </v-row>
    
    <v-row justify="end" align="center" v-if="pagination.total_page > 1">
      <v-col cols="12" md="2" class="d-flex align-center justify-end">
        <v-btn
          color="#4FC3F7"
          :disabled="pagination.current === 1"
          elevation="3"
          min-width="36"
          class="text-capitalize white--text px-0 mr-3"
          @click="selected.pagination = 1">
          <v-icon>mdi-chevron-double-left</v-icon>
        </v-btn>
        <v-btn
          color="#263238"
          :disabled="pagination.current < 2"
          elevation="3"
          min-width="36"
          class="text-capitalize white--text px-0"
          @click="selected.pagination = selected.pagination-1">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <div class="mx-5" style="width: 75px;">
          <v-autocomplete
            v-model="selected.pagination"
            :items="pagination.detail"
            color="#263238"
            auto-select-first
            outlined
            dense
            single-line
            hide-details
            hide-selected>
            <template v-slot:selection="{ item }">
              {{ item }}
            </template>
          </v-autocomplete>
        </div>
        <v-btn
          color="#263238"
          elevation="3"
          min-width="36"
          class="text-capitalize white--text px-0"
          :disabled="pagination.current >= pagination.total_page"
          @click="selected.pagination = selected.pagination+1">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn
          color="#4FC3F7"
          :disabled="pagination.current === pagination.total_page"
          elevation="3"
          min-width="36"
          class="text-capitalize white--text px-0 ml-3"
          @click="selected.pagination = pagination.total_page">
          <v-icon>mdi-chevron-double-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../service/Axios";
  export default {
    data () {
      return {
        selected: {
          year: 0,
          pagination: 1
        },
        filter: {
          title: '',
          category: '',
          location: '',
          year: ''
        },
        config: {
          category: [],
          start: new Date().getFullYear()
        },
        list: [],
        pagination: {},
        process: {
          run: false
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      years () {
        let start = [{
          label: 'Semua',
          value: ''
        }]
        for (let i = this.config.start; i >= this.config.start - 50; i-=1) {
          start.push({
            label: i,
            value: i
          })
        }
        return start
      }
    },
    watch: {
      'filter.category': function(val) {
        this.fetch()
      },
      'filter.location': function(val) {
        this.fetch()
      },
      'selected.year': function(val) {
        this.filter.year = this.years[val].value
        this.fetch()
      },
      'selected.pagination': function(val) {
        this.fetch(val)
      }
    },
    mounted () {
      this.setting().category()
      this.fetch()
    },
    methods: {
      async fetch(p) {
        this.process.run = true

        let params = {
          page: p,
          limit: 12,
          filter: [
            {
              type: 'string',
              field: 'project_name',
              value: this.filter.title,
              comparison: '<>'
            },
            {
              type: 'string',
              field: 'project_category_name',
              value: this.filter.category,
              comparison: '<>'
            },
            {
              type: 'string',
              field: 'project_address',
              value: this.filter.location,
              comparison: '<>'
            },
            {
              type: 'string',
              field: 'input_year',
              value: this.filter.year,
              comparison: '='
            }
          ]
        }

        await get(`auth/company/project/list`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.list = res.data.results
            this.pagination = res.data.pagination
            this.pagination.current = parseInt(this.pagination.current)
          } else if (res.status === 400 && res.error_code === "error_failed") {
            this.process.run = false
            this.$router.push({ path: '/404' })
          }
        })
        .catch((error) => {
          this.process.run = false
          this.$router.push({ path: '/404' })
        })
      },
      setting() {
        let t = this
        return {
          async category() {
            get(`project/category/get-list-option`)
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.category = res.data.results
              }
            })
          }
        }
      },
      setPlace(place) {
        this.filter.location = place.formatted_address
      }
    }
  }
</script>

<style scoped>
.min-height {
  min-height: 590px;
}
</style>
